import { define } from 'remount'
import NodeList from './node/list'
import Menu from './menu'
import NodeAdd from './node/add'

define({
  'node-add': { component: NodeAdd, attributes: [] },
  'node-list': { component: NodeList, attributes: [] },
  'side-menu': { component: Menu, attributes: [] },
})
